import { css, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { Style } from "../Styles";

import { Form } from "./Form";
import { FormsT } from "./FormTypes";
import { watch } from "../internal/watch";

@customElement("ds-form")
export class FormControl extends Form {
    static override styles = [
        Style,
        css`
            :host {
                display: block;
            }
            .grid-3-column {
                grid-template-columns: minmax(auto, 30%) auto min-content;
            }
            .grid-3-column sl-select {
                width: 100%;
            }

            .grid-3-column .editor-label {
                margin-top: 0em;
                margin-bottom: 0em;
                display: block;
                text-align: center;
            }
        `,
    ];

    @property({ type: Array }) fields: FormsT[] = [];
    @property({ type: Object }) object?: any;

    @watch("object")
    onObjectChanged() {
        this._object = undefined;
        if (this.object) {
            this._object = this.object;
        }
    }

    protected override _raiseFormChanged() {
        super._raiseFormChanged();
        this._raiseEvent("ds-form-changed", {
            object: this._object,
        });
    }

    override render() {
        return html`<div class="flex-column">${this._renderForm(this.fields)}</div>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "ds-form": FormControl;
    }
}
